import ButtonDigital from './ButtonDigital';

export default ButtonDigital;
